import "./index.css";

export default function ProgressBar() {
  return <span className="loader" />;
}
